import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { FormeJuridiqueDto, PaysDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-forme-juridique-select',
  templateUrl: './forme-juridique-select.component.html',
  styleUrls: ['./forme-juridique-select.component.css']
})
export class FormeJuridiqueSelectComponent implements OnInit {
  @Select(ControlPanelStore.formesJuridiques$) formesJuridiques$: Observable<FormeJuridiqueDto[]>;

  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  @Input() disabled: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() formeJuridiqueId: number;
  @Output() formeJuridiqueIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  FormesJuridiques: FormeJuridiqueDto[] = [];
  ColumnName = [];

  fj: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
      this.translate.get(
        [
          'Identifiant',
          'Reference'
        ]
        ).subscribe(translations => {
          this.ColumnName.push(translations['Identifiant']);
          this.ColumnName.push(translations['Reference']);
        });
    }

  ngOnInit() {
    if(this.formeJuridiqueId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.formeJuridiqueId));
    }
    this.fj = this.formesJuridiques$.subscribe(res => {
      if (res != null) {
        this.FormesJuridiques = res;
      }
    });
  }

  ngOnDestroy() {
    this.fj?.unsubscribe();
  }

  updateInfo(event) {
    this.formeJuridiqueId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.formeJuridiqueId;
    if (!!this.cell && this.InitId != this.formeJuridiqueId) {
      this.cell.setValue(this.formeJuridiqueId);
    }
    this.formeJuridiqueIdChange.emit(this.formeJuridiqueId);

    if(this.formeJuridiqueId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.formeJuridiqueId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
